module.exports = __webpack_public_path__ + "img/Yes_active.1ef2261f.png";